export default __webpack_public_path__ + "static/media/bgalt2.69c424dd.jpg";